/* .modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;
}

.modal-content {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
}

.form-group {
  margin-bottom: 1rem;
}

.input-group {
  display: flex;
}

input {
  flex-grow: 1;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

input.invalid {
  border-color: #dc3545;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

button {
  padding: 0.5rem 1rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #0056b3;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.button-group {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.input-group button {
  margin-left: 0.5rem;
}

textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
}

.snackbar {
  position: fixed;
  left: 20px;
  bottom: 20px;
  background-color: #333;
  color: #fff;
  padding: 16px;
  border-radius: 4px;
  z-index: 1000;
}


.captcha-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.captcha-image {
  max-width: 200px;
  margin-right: 10px;
}

.refresh-captcha {
  padding: 5px 10px;
}

 */

.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 1000;
  overflow: hidden;
  /* padding: 20px; */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);

}




.modal-content {
  margin: 20px;
  background: #fff;
  padding: 0px 20px 14px 20px;
  /* border-radius: 8px; */
  max-width: 500px;
  width: 100%;
  border-radius: 22px;
}

.form-group {
  /* margin-top: 1rem; */
  margin-bottom: 1rem;
}

.input-group {
  display: flex;
  align-items: center;
}

.input-container {
  position: relative;
  width: 100%;
}

input,
textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-family: Arial, Helvetica, sans-serif;
}

input[type="number"] {
  border-radius: 0px 4px 4px 0px !important;
}

input:focus-visible,
textarea:focus-visible,
select:focus-visible {
  outline: none;
  border-color: #02A69C !important;
}


.invalid {
  border-color: red;
}

.close-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999;
  font-size: 1.2rem;
}

.close-icon:hover {
  color: #333;
}

.error-message {
  color: red;
  font-size: 0.875rem;
  margin-top: 0.5rem;
}

.button-group {
  display: flex;
  justify-content: end;
}

button {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: #ffffff;
  background-color: #02A69C;
  transition: background-color 0.3s;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.mr {
  margin-right: 12px;
}

/* label::after {
  content: '';
  color: red;
  margin-left: 0.25rem;
} */

.required {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}

label {
  font-family: Arial, Helvetica, sans-serif;
}

.otp-button {
  margin-left: auto;
  text-decoration: underline;
  color: #0B1B43;
  font-size: 14px;
  font-family: Arial, Helvetica, sans-serif;
}

.gg {
  display: flex;
  align-items: center;
}

.otp-verification {
  margin-top: 16px;
  margin-bottom: 16px;
  /* display: flex; */

  /* input {
    width: 66% !important;
  } */

  button {
    margin-left: auto;
  }
}

.sub {
  display: flex;
  margin-left: auto;
  flex-direction: row-reverse;
}

h2 {
  /* background-color:#02A69C ; */
  color: #02A69C;
  font-family: Arial, Helvetica, sans-serif;
}

.isd-container {
  display: flex;
  align-items: center;
  /* gap: 8px; */
}

.isd-select {
  /* padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px; */

  width: 47%;
  /* padding: 0.5rem; */
  padding: 7px;
  border: 1px solid #ccc;
  /* border-radius: 4px; */
  border-radius: 4px 0px 0px 4px;
  border-right: unset;
  box-sizing: border-box;
  font-family: Arial, Helvetica, sans-serif;
}

.option {
  font-family: Arial, Helvetica, sans-serif !important;
  font-size: 14px !important;
}

.error-message {
  font-family: Arial, Helvetica, sans-serif;
}

.message {
  /* padding: 20px; */
  font-family: Arial, Helvetica, sans-serif;
  font-size: 20px;
  line-height: 25px;
}